var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_vm._m(0),_c('div',{staticClass:"error-desc"},[_vm._v(_vm._s(_vm.$t('COMMON_004')))]),_c('div',{staticClass:"error-handle"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-code"},[_vm._v("4"),_c('span',[_vm._v("0")]),_vm._v("3")])
}]
render._withStripped = true
export { render, staticRenderFns }